import useReveal from "@/hooks/useReveal";

const SIDE_PROFILE =
  "https://customer-assets.emergentagent.com/job_afrqa-luxury/artifacts/31u5d5k2_3eb31fc8-5e84-49b0-81ae-8fee1cb47ade.JPG";

const HIGHLIGHTS = [
  {
    no: "01",
    title: "Thin Gold-Tone Temples",
    body: "Slim, hand-polished metal arms sit weightlessly on the temple — engineered for all-day editorial wear.",
  },
  {
    no: "02",
    title: "Acetate Tip Comfort",
    body: "Matte black acetate end-pieces with a subtle curvature for grip without pressure.",
  },
  {
    no: "03",
    title: "Featherweight Build",
    body: "Lightweight architecture that disappears on the face, with no compromise on luxury presence.",
  },
];

export default function Craftsmanship() {
  const r1 = useReveal();
  const r2 = useReveal();

  return (
    <section
      data-testid="craftsmanship-section"
      className="relative bg-[#0a0a0a] py-24 md:py-36 overflow-hidden"
    >
      {/* Ambient gold glow */}
      <div
        aria-hidden
        className="absolute right-0 top-1/3 w-[420px] h-[420px] rounded-full pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, rgba(212,175,55,0.10) 0%, transparent 65%)",
          filter: "blur(20px)",
        }}
      />

      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <div
            ref={r1.ref}
            className={`reveal ${r1.inView ? "in-view" : ""} lg:col-span-7`}
          >
            <div className="relative zoom-wrap prototype-photo bg-[#0c0c0c] border border-[#1f1f1f] aspect-[5/4]">
              <img
                src={SIDE_PROFILE}
                alt="The Africa Frame — side profile prototype detail"
                className="w-full h-full object-cover"
                data-testid="craftsmanship-image"
              />
              <span
                aria-hidden
                className="absolute inset-0 pointer-events-none"
                style={{
                  background:
                    "radial-gradient(ellipse at center, transparent 55%, rgba(0,0,0,0.42) 100%)",
                }}
              />
              <span
                className="absolute top-5 left-5 inline-flex items-center gap-2 bg-black/60 backdrop-blur-md border border-[#d4af37]/50 text-[#d4af37] font-label py-1.5 px-3"
                data-testid="craftsmanship-prototype-tag"
              >
                <span className="pulse-dot" />
                Side Profile · Real Prototype
              </span>
            </div>
          </div>

          {/* Copy */}
          <div
            ref={r2.ref}
            className={`reveal reveal-delay-1 ${
              r2.inView ? "in-view" : ""
            } lg:col-span-5`}
          >
            <span className="font-label text-[#d4af37]">
              — The Craftsmanship —
            </span>
            <h2 className="mt-4 font-display text-[clamp(1.9rem,4.4vw,3.6rem)] leading-[1.06] tracking-tight text-white">
              Weightless on the face.{" "}
              <span className="font-editorial italic gold-text-gradient">
                Heavy in heritage.
              </span>
            </h2>
            <p className="mt-6 text-[#bdbdb7] text-lg leading-relaxed max-w-md font-light">
              Luxury eyewear inspired by heritage, culture, and futuristic
              design — the prototype is complete, and every millimetre has been
              considered.
            </p>

            <div className="mt-10 space-y-1">
              {HIGHLIGHTS.map((h) => (
                <div
                  key={h.no}
                  className="grid grid-cols-12 gap-4 py-5 border-t border-[#1f1f1f]"
                  data-testid={`craftsmanship-item-${h.no}`}
                >
                  <div className="col-span-2 font-editorial italic gold-text-gradient text-2xl leading-none pt-1">
                    {h.no}
                  </div>
                  <div className="col-span-10">
                    <p className="font-display text-white text-lg">{h.title}</p>
                    <p className="mt-2 text-[#a3a3a3] leading-relaxed font-light text-sm">
                      {h.body}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
